import React from 'react'

import type { MenuProps } from 'antd'
import { Dropdown, Modal } from 'antd'
import { useAtomValue, useSetAtom } from 'jotai'
import Cookies from 'js-cookie'
import { useLocation } from 'react-router-dom'

import { Personal } from '@/components/Personal'
import { HOME_URL } from '@/config'
import { useCustomNavigate } from '@/hooks/useCustomNavigate'
import { userLogout } from '@/httpRequest/modules/user/logout'
import { useSearchValAtom } from '@/store/home'
import { useStoryPageModeAtom } from '@/store/publish'
import { loginStateAtom, useUserAtom } from '@/store/user'
import { getGlobalConfig } from '@/utils'
import {
  handlePublishClickTrack,
  handleSearchInputTrack
} from '@/utils/trackSensors'
import edit from '@img/header/edit.png'
import search from '@img/header/search.png'
import imgAvatar from '@img/home/img.png'
import logo from '@img/logo.png'
import personal from '@img/personal/Default@3x.png'

import './index.less'

interface Header {
  showAction?: boolean
}

const ENVIRONMENT = getGlobalConfig().VITE_ENVIRONMENT
const helpCenterUrl = ['test', 'dev'].includes(ENVIRONMENT)
  ? 'https://help-test.mespery.com/'
  : 'https://help.mespery.com'

const CREATING_URL = getGlobalConfig().VITE_WRITING_STATION_URL

const LayoutHeader = ({ showAction = false }: Header) => {
  const [modal, contextHolder] = Modal.useModal()

  const { customNavigator } = useCustomNavigate()
  const location = useLocation()
  const setLoginStatus = useSetAtom(loginStateAtom)
  const isLogin = useAtomValue(loginStateAtom)
  const { user } = useUserAtom()
  const { isEdit, handleEditCheck } = useStoryPageModeAtom()
  const { setSearchVal } = useSearchValAtom()

  const handleNavigateCheck = (callback: () => void) => {
    if (location.pathname.includes('/publish')) {
      handleEditCheck(isEdit, callback)
    } else {
      callback()
    }
  }

  const logout = async () => {
    const logoutResult = await userLogout()
    if (logoutResult) {
      setLoginStatus(false)
      Cookies.remove('token')
      window.localStorage.removeItem('token')
      window.localStorage.removeItem('userInfo')
      window.localStorage.removeItem('refreshToken')
      customNavigator('/login')
    }
  }
  const publishMenus: MenuProps['items'] = [
    // {
    //   key: '1',
    //   label: (
    //     <div
    //       rel="noopener noreferrer"
    //       className="global-header-dropdown-link"
    //       onClick={() => {
    //         handleNavigateCheck(() => {
    //           if (location.pathname === '/publish') {
    //             window.history.replaceState({}, '', '/publish')
    //             window.location.reload()
    //           } else {
    //             navigate('/publish')
    //           }
    //         })
    //       }}
    //     >
    //       <h4>Story</h4>
    //       <p>Novel</p>
    //     </div>
    //   )
    // }
    // {
    //   key: '3',
    //   label: (
    //     <div
    //       rel="noopener noreferrer"
    //       className="global-header-dropdown-link"
    //       onClick={() => {
    //         handleNavigateCheck(() => {
    //           if (location.pathname === '/publish/discuss') {
    //             window.history.replaceState({}, '', '/publish/discuss')
    //             window.location.reload()
    //           } else {
    //             navigate('/publish/discuss')
    //           }
    //         })
    //       }}
    //     >
    //       <h4>Discuss</h4>
    //       <p>Chat With The Community</p>
    //     </div>
    //   )
    // }
  ]

  const userMenus: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div
          rel="noopener noreferrer"
          className="global-header-dropdown-link"
          onClick={() => {
            handleNavigateCheck(() => {
              customNavigator('/profile')
            })
          }}
        >
          <h4>Profile</h4>
        </div>
      )
    },
    // {
    //   key: '2',
    //   label: (
    //     <div
    //       rel="noopener noreferrer"
    //       className="global-header-dropdown-link"
    //       onClick={() => {
    //         handleNavigateCheck(() => {
    //           window.open(helpCenterUrl)
    //         })
    //       }}
    //     >
    //       <h4>Support</h4>
    //     </div>
    //   )
    // },
    {
      key: '3',
      label: (
        <a
          rel="noopener noreferrer"
          onClick={() => {
            handleNavigateCheck(() => {
              logout()
            })
          }}
          className="global-header-dropdown-link"
        >
          <h4>Logout</h4>
        </a>
      )
    }
  ]

  return (
    <header className="global-layout-header">
      <div
        className="logo"
        onClick={() => {
          handleNavigateCheck(() => {
            customNavigator(HOME_URL)
          })
        }}
      >
        <img src={logo} alt="logo" width="157" />
      </div>
      {showAction && (
        <div className="flx-align-center actions">
          <img src={search} alt="search" width="15" className="search" />
          <input
            onKeyDown={(e) => {
              console.log(e.key)
              if (e.key === 'Enter') {
                customNavigator('/searchResult')
              }
            }}
            onChange={(e) => {
              setSearchVal(e.target.value)
            }}
            onFocus={() => {
              handleSearchInputTrack()
            }}
          />
          {isLogin ? (
            <div>
              {/* <Dropdown
                menu={{ items: publishMenus }}
                getPopupContainer={(): HTMLElement =>
                  document.querySelector('header-publish-wraper') as HTMLElement
                }
                placement="bottom"
                overlayClassName="global-header-dropdown-publish"
                onOpenChange={(open) => {
                  if (open) {
                    handlePublishClickTrack()
                  }
                }}
              >
                <div className="header-publish-wraper">
                  <button className="g-btn g-btn-primary btn-publish">
                    Publish
                  </button>
                  <img src={edit} alt="edit" width="36" className="edit" />
                </div>
              </Dropdown> */}
              <div className="header-publish-wraper publish-box">
                <button
                  className="g-btn g-btn-primary btn-publish"
                  onClick={() => {
                    const token = localStorage.getItem('token') || ''
                    const tokenExpire =
                      localStorage.getItem('tokenExpire') || ''
                    const refreshToken =
                      localStorage.getItem('refreshToken') || ''
                    // 设置 token 到 cookie
                    Cookies.set('token', token, {
                      expires: new Date(Number(tokenExpire) * 1000),
                      domain: '.mespery.com'
                    })
                    Cookies.set('refreshToken', refreshToken, {
                      expires: new Date(Number(tokenExpire) * 1000),
                      domain: '.mespery.com'
                    })
                    Cookies.set('tokenExpire', tokenExpire, {
                      expires: new Date(Number(tokenExpire) * 1000),
                      domain: '.mespery.com'
                    })
                    window.location.href = CREATING_URL
                  }}
                >
                  Creating Center
                </button>
                <img src={edit} alt="edit" width="36" className="edit" />
              </div>
            </div>
          ) : (
            <a
              className="g-btn g-btn-primary"
              onClick={() => {
                customNavigator('/login')
              }}
            >
              Log in
            </a>
          )}
          <div className="personal">
            {isLogin && (
              <>
                <Dropdown
                  menu={{ items: userMenus }}
                  dropdownRender={(menu) => (
                    <div className="global-header-dropdown-user">
                      <div className="global-header-user">
                        <Personal
                          avatar={user.avatar_url || personal}
                          nickname={user.nickname || ''}
                          userData={user}
                        />
                      </div>
                      {React.cloneElement(menu as React.ReactElement)}
                    </div>
                  )}
                  getPopupContainer={(): HTMLElement =>
                    document.querySelector('header-user-wraper') as HTMLElement
                  }
                  placement="bottom"
                >
                  <a className="header-user-wraper">
                    <img
                      src={user.avatar_url || personal}
                      width="30"
                      className="avatar-img"
                    />
                  </a>
                </Dropdown>
                {contextHolder}
              </>
            )}
          </div>
        </div>
      )}
    </header>
  )
}

export default LayoutHeader
